import React from 'react';
import { Dialog } from '../ui';

export interface DrawerModalProps {
  open: boolean;
  onClose: () => void;
  header: React.ReactNode;
  children: React.ReactNode;
  footer: React.ReactNode;
  maxWidth?: string;
  className?: string;
}

export const DrawerModal: React.FC<DrawerModalProps> = ({
  open,
  onClose,
  header,
  children,
  footer,
  maxWidth = 'max-w-[848px]',
  className,
}) => {
  return (
    <>
      <style>
        {`
          @media (max-width: 767px) {
            dialog[open].drawer-modal {
              top: auto;
              bottom: 0;
              margin: 0;
              padding: 0 !important;
              height: calc(100vh - 2rem) !important;
              max-height: calc(100vh - 2rem) !important;
            }
            dialog[open].drawer-modal > div {
              height: 100% !important;
              max-height: 100% !important;
            }
          }
        `}
      </style>
      <Dialog
        className={`drawer-modal backdrop:bg-modalBackdropColor rounded-b-0 w-full ${maxWidth} rounded-t-3 border-input-border-gray border-l border-r border-t bg-white md:m-auto md:max-h-[90vh] md:rounded-xl md:border ${className || ''}`}
        open={open}
        onClose={onClose}
        contentClassName="flex flex-col h-full overflow-hidden md:h-auto md:max-h-[90vh] md:m-auto"
      >
        <div className="relative flex h-full min-h-0 flex-col overflow-hidden">
          {/* Fixed Header */}
          <div className="border-input-border-gray shrink-0 border-b px-[23px] py-4">{header}</div>

          {/* Scrollable Body */}
          <div className="min-h-0 flex-1 overflow-y-auto pb-[84px] md:pb-0">{children}</div>

          {/* Fixed Footer */}
          <div className="border-input-border-gray absolute bottom-0 left-0 right-0 z-10 flex shrink-0 items-center justify-center gap-4 border-t bg-white px-[23px] pb-4 pt-6 md:static md:items-end md:justify-end md:pb-0">
            {footer}
          </div>
        </div>
      </Dialog>
    </>
  );
};
